module.exports = __webpack_public_path__ + "media/images/step-two-selected-62000053.svg";